import React from 'react';
import { Settings, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const MaintenancesSSI = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center gap-4">
        <button
          onClick={() => navigate('/dashboard/ssi')}
          className="p-2 hover:bg-gray-100 rounded-lg"
        >
          <ArrowLeft className="h-6 w-6" />
        </button>
        <div>
          <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
            <Settings className="h-8 w-8 text-blue-600" />
            Maintenances SSI
          </h1>
          <p className="text-gray-600 mt-1">Vérifications & interventions périodiques</p>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-8 text-center">
        <Settings className="h-16 w-16 mx-auto mb-4 text-blue-500" />
        <h2 className="text-2xl font-bold text-blue-900 mb-2">Module Maintenances SSI</h2>
        <p className="text-blue-700 mb-4">
          Gestion des vérifications périodiques réglementaires (mensuelles, trimestrielles, semestrielles, annuelles)
        </p>
        <div className="text-sm text-blue-600 space-y-2">
          <p>✅ Planification des interventions</p>
          <p>✅ Suivi des maintenances préventives</p>
          <p>✅ Rapports de conformité</p>
          <p>✅ Historique des interventions</p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancesSSI;
